// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const sandshrew_alola: PokeData = {
  "id": 10101,
  "name": "sandshrew-alola",
  "height": 7,
  "weight": 400,
  "base_experience": 60,
  "types": [
    PokeType.ICE,
    PokeType.STEEL
  ],
  "api_moves": [
    "ice-punch",
    "scratch",
    "swords-dance",
    "mist",
    "blizzard",
    "defense-curl",
    "bide",
    "swift",
    "fury-swipes",
    "slash",
    "powder-snow",
    "rollout",
    "fury-cutter",
    "rapid-spin",
    "metal-claw",
    "mirror-coat",
    "hail",
    "ice-ball",
    "iron-defense",
    "gyro-ball",
    "ice-shard",
    "iron-head",
    "snowscape"
  ],
  "moves": [
    "ice-punch",
    "scratch",
    "blizzard",
    "metal-claw",
    "ice-shard",
    "hailstorm",
    "aurora-veil",
    "behemoth-bash",
    "smart-strike",
    "steel-beam",
    "metal-rush",
    "ice-fang",
  ],
  "evolution_chain": {
    "id": 11,
    "item": null,
    "species": [
      {
        "name": "sandshrew",
        "order": 28,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sandslash",
        "order": 29,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 27,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "ice-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 113,
    "speed": 80,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "alola"
} as const;
